import React from "react";
import { FormControl, FormHelperText } from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import enzaLocale from "date-fns/locale/en-ZA";
const DateAdapter = ({ 
  input,
  meta, 
  label, 
  ...rest
}) => {
  return (
    <>
      <FormControl error={meta.error && meta.touched} {...rest}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enzaLocale}>
          <DatePicker
            {...rest}
            views={["year", "month", "day"]}
            label={label}
            required={true}
            value={input.value && new Date(input.value)}
            onChange={(value) =>
              value && input.onChange(value.toLocaleDateString("se-SE"))
            }
            format="yyyy-MM-dd"
            inputFormat="yyyy-MM-dd"
            slotProps={{
              textField: {
                size: "small",
                margin: "dense",
                helperText: null,
              },
            }}

          />
        </LocalizationProvider>
        {meta.error && meta.touched ? (
          <FormHelperText>{meta.error}</FormHelperText>
        ) : (
          <></>
        )}
      </FormControl>
    </>
  );
};

export default DateAdapter;
